import { useLocation } from "react-router";
import React, { useState, useEffect, useHistory } from "react";

import axios from "axios";
import jwt_decode from "jwt-decode";
import "../modal.css";

import Table from "../Theme/Table.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../Spinner";
import { Checkbox, Modal } from "antd";
import { Button } from "react-bootstrap";
import { handleExportClick } from "../exportFile";
import ActionButtons from "../../components/Trip/TripsActionButton.js";
const CreditsList = () => {
  const location = useLocation();
  const [credits, setCredits] = useState([]);
  let [loading, setLoading] = useState(true);
  
  const getCredits = async () => {
  try {
    const response = await axios.get("credits/");
    const newCred = response.data.map((re) => {
      return {
        ...re,
        driver: {
          ...re.driver,
          name: re.driver?.firstName + " " + re.driver?.lastName,
        },
        createdAt: new Intl.DateTimeFormat('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        }).format(new Date(re.createdAt)), // Formatting the transaction date
      };
    });
    console.log("===========credits=========", newCred);
    setCredits(newCred);
    setLoading(false);
    notify();
  } catch (err) {
    console.error(err);
    notifyError();
  }
};

  const notify = () =>
    toast.success("Credit list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  useEffect(() => {
    getCredits();
  }, [location.key]);
  const columns = React.useMemo(
    () => [
      {
        Header: "Driver Information",
        columns: [
          {
            Header: "Id",
            accessor: "id",
          },

          {
            Header: "First Name",
            accessor: "driver.firstName",
          },
          {
            Header: "Last Name",
            accessor: "driver.lastName",
          },
          {
            Header: "Phone Number",
            accessor: "driver.phoneNumber",
          },
        ],
      },

      {
        Header: "Others",
        columns: [
          {
            Header: "Amount",
            accessor: "amount",
          },
          {
            Header: "Transaction Date",
            accessor: "createdAt",
          },
        ],
      },
    ],
    []
  );

  const columns_expo = React.useMemo(
    () =>
      [
        {
          columns: [
            {
              Header: "Id",
              accessor: "id",
            },
          ],
        },
        {
          Header: "Driver",
          columns: [
            { Header: "Driver Name", accessor: "driver.name" },
            // { Header: "Last Name", accessor: "passenger.lastName" },
            { Header: "Driver Phone", accessor: "driver.phoneNumber" },
          ],
        },
        {
          Header: "Others",
          columns: [
            {
              Header: "Amount",
              accessor: "amount",
            },
            {
              Header: "Transaction Date",
              accessor: "createdAt",
            },
          ],
        },
      ].flatMap((group) => group.columns),
    []
  );

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const [selectedColumns, setSelectedColumns] = useState(
    columns_expo.map((column) => column.Header)
  );

  const handleOkModal = () => {
    console.log("handleOkModal called");
    setIsModalVisible(false);
    handleExportClick(
      credits,
      columns_expo,
      "Driver Credit",
      "driver_credits.pdf",
      selectedColumns
    );
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // Inside your component
  function handleColumnToggle(columnHeader) {
    setSelectedColumns((prevSelectedColumns) => {
      if (prevSelectedColumns.includes(columnHeader)) {
        return prevSelectedColumns.filter((col) => col !== columnHeader);
      } else {
        return [...prevSelectedColumns, columnHeader];
      }
    });
  }

  return (

    <div className="content-wrappers" style={{ marginTop: '-40px' }}>
    <div className="content-wrappers">
      <br />
      <br />
      <ToastContainer />

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                 <ActionButtons title="Driver Credits" showModal={showModal} />
                  <Modal
                    title="Select Columns to Export"
                    visible={isModalVisible}
                    onOk={handleOkModal}
                    onCancel={handleCancel}
                    footer={[
                      <Button key="cancel" onClick={handleCancel}>
                        Cancel
                      </Button>,
                      <Button
                        style={{ marginLeft: "10px" }}
                        key="ok"
                        type="primary"
                        onClick={handleOkModal}
                      >
                        OK
                      </Button>,
                    ]}
                  >
                    <div style={{ marginBottom: "20px" }}>
                      {columns_expo.map((column) => (
                        <div
                          key={column.Header}
                          style={{ marginBottom: "10px" }}
                        >
                          <Checkbox
                            checked={selectedColumns.includes(column.Header)}
                            onChange={() => handleColumnToggle(column.Header)}
                            style={{ marginRight: "10px", fontSize: "16px" }}
                          >
                            {column.Header}
                          </Checkbox>
                        </div>
                      ))}
                    </div>
                  </Modal>

                <div className="card-body">
                  {loading && (
                    <div>
                      <Spinner />
                    </div>
                  )}
                  {!loading && <Table columns={columns} data={credits} />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    </div>
  );
};

export default CreditsList;
